(function ($) {

  const $body = $('html');
  var spcsScrolled = true;
  
  function spcs_scrolled() {
      if (!spcsScrolled) return;
      spcsScrolled = false;
    
      let offset = window.innerWidth > window.innerHeight  ? (window.innerHeight / 3) : (window.innerHeight / 1.5) ;
      if ($(this).scrollTop() > offset) {
          $body.addClass('spcs-scrolled').removeClass('spcs-scrolled-top');
      } else {
          $body.addClass('spcs-scrolled-top');
      }
  }
  
  spcs_scrolled();
  setInterval(spcs_scrolled, 25);
  
  $(window).scroll(function() {
    spcsScrolled = true;
  });

  
    $(document).on('mouseup tap', function(e) {
      $(".selector-container:visible").each(function() {
        var container = $(this);
        if (!container.is(e.target) || container.has(e.target).length > 0) {
            container.prev('.selector-handle').removeClass('open');
            container.fadeOut(250);
        }  
      });
    });
  
  
  
    $(function () {
  
      const data = JSON.parse($('#spcs-data-json').text() || '{}');
      if (!data || !Object.keys(data).length) return;
  
      for (let helppopups of Object.keys(data.crosssell.help)) {
        (function(popupdata) {
          const popupid = popupdata.id;
          const url = popupdata.url;
  
          $.get(url, function(result) {
            $('<div id="' + popupid + '" class="bbpopup__overlay">'+
                '<div class="bbpopup__box">' + 
                  '<div class="bbpopup__close"><a href="#">&times;</a></div>'+
                  '<div class="bbpopup__content">'+ $(result).find('#page').html() +'</div>'+
                '</div>'+
              '</div>').appendTo('body');
          });
          
        })(data.crosssell.help[helppopups]);
      }

      data.product.model = data.product.model || [""];
      
      data.product.option1 = null;
      data.product.option2 = null;
      data.product.option3 = null;

      data.product.option1_is = null;
      data.product.option2_is = null;
      data.product.option3_is = null;


      var typeRegex = new RegExp('('+  Object.keys(data.crosssell.types).join('|') +')', 'i');
      
      for (let op of data.product.options) {
        data.product["option" + op.position] = op;
        if (!op.values || !op.values.length) continue;

        if (op.values.join( ).match(typeRegex)) {
          data.product["option" + op.position + '_is'] = "system";
        } else if (op.values.join(' ').indexOf('iPhone') >= 0 || op.values.join(' ').indexOf('Galaxy') >= 0 || op.values.join(' ').indexOf('Pixel') >= 0) {
          data.product["option" + op.position + '_is'] = "model";
        }
     }
    

      
      const prodFI = data.product.featuredImage;
      data.product.featuredImage = null;
      for (let variant of data.product.variants) {
        const varFI = variant.featuredImage || prodFI;
        const dropIcon = variant.dropdownIcon || varFI;
        const dropPic = variant.dropdownPictures ? variant.dropdownPictures[0] : varFI;

        variant.model = variant.model || [""];
        
        variant.featuredImage = {
          "image":  varFI,
          "dropdown": dropPic,
          "icon": dropIcon
        };
        if (!data.product.featuredImage) {
          data.product.featuredImage = variant.featuredImage;
        }
      }

      if (data.crosssell && data.crosssell.config && data.crosssell.config.discount) {
        if (data.crosssell.config.discount.length) {
          for(let discountpart of data.crosssell.config.discount) {
            for (let part of data.parts[discountpart.section]) {
              part.price = {
                regular: part.price,
                sale: part.price * ((100 - discountpart.percent) / 100)
              };
              for (let variant of part.variants) {
                variant.price = {
                  regular: variant.price,
                  sale: variant.price * ((100 - discountpart.percent) / 100)
                };
              }
            } 
          }   
        }
      }

      function isDiscounted(part) {
        if (data.crosssell && data.crosssell.config && data.crosssell.config.discount) {
          if (data.crosssell.config.discount.length) {
            for(let discountpart of data.crosssell.config.discount) {
              if (discountpart.section == part) return true;
            }
          }
        }
        return false;
      }
      
      if (data.parts) {
        for (let type of Object.keys(data.parts)) {
          if (!data.parts[type]) continue;
          
          for (let part of data.parts[type]) {
            if (part.variants.length == 0) continue;
            
            const partFI = part.featuredImage;
            part.featuredImage = null;
            for (let variant of part.variants) {
              const varFI = variant.featuredImage || partFI;
              const dropIcon = variant.dropdownIcon || varFI;
              const dropPic = variant.dropdownPictures ? variant.dropdownPictures[0] : varFI;
              
              variant.featuredImage = {
                "image":  varFI,
                "dropdown": dropPic,
                "icon": dropIcon
              };
              if (!part.featuredImage) {
                part.featuredImage = variant.featuredImage;
              }
            }
          }  
        }  
      }
      
  
      const container = $('.product-blocks:eq(0)');
      container.attr('id', 'spcs-container');
      
      const optionContainer = $('<div class="spcs-container-options">');
      optionContainer.insertBefore($('.product-blocks__block--variant_picker', container));

      const extrasContainer = $('<div class="spcs-container-extras">');
      
      let extrasPos = $('.product-blocks__block--buttons', container);
      if (extrasPos.length) {
        extrasContainer.insertAfter(extrasPos);
      } else {
        extrasContainer.insertAfter($('.product-blocks__block--spcs-extras', container));
      }
      
      $('.product-blocks__block--variant_picker').each(function() {
        $(this).hide();
      });
      $('.product-recommendations__wrapper, .recently-viewed').each(function () {
        $(this).closest('.shopify-section').hide();
      });
      $('.system_compatibility_link').hide();

      const option1Container = $('<div id="spcs-option1">').appendTo(optionContainer);
      const option2Container = $('<div id="spcs-option2">').appendTo(optionContainer);
      const option3Container = $('<div id="spcs-option3">').appendTo(optionContainer);        
      const deliverydateContainer = $('<div id="spcs-deliverydate">').appendTo(optionContainer);
      
      
      const mountContainer = $('<div id="spcs-mounts">').appendTo(extrasContainer);
      const mposcont = $('<div id="spcs-mountpos-sel">').appendTo(mountContainer);
      const mcont = $('<div id="spcs-mount-sel">').appendTo(mountContainer);
      
      const protectionContainer = $('<div id="spcs-proptection">').appendTo(extrasContainer);
      const inlinecartContainer = $('<div id="spcs-inlinecart">');
      
      if (data.parts.phoneCases && data.parts.phoneCases.length) {
        mountContainer.appendTo(optionContainer);
        protectionContainer.appendTo(optionContainer);
        
        
      }
      inlinecartContainer.appendTo(optionContainer); //Buy Button
      
      const dampeningContainer = $('<div id="spcs-dampening">').appendTo(extrasContainer);
      const powerbankContainer = $('<div id="spcs-powerbank">').appendTo(extrasContainer);
      const chargingContainer = $('<div id="spcs-charging">').appendTo(extrasContainer);
      const cableContainer = $('<div id="spcs-cable">').appendTo(extrasContainer);
      
      const otherMountsContainer = $('<div id="spcs-othermounts">').appendTo(extrasContainer);
      const addOnsContainer = $('<div id="spcs-addons">').appendTo(extrasContainer);
      
      const cartContainer = $('<div id="spcs-cart">').appendTo('body');
  
  
      const bundleCart = {
        bundle: data,
        product: null,
        mount: null,        
        protection: null,
        dampening: null,
        powerbank: null,
        charging: null,
        cable: null,
        otherMounts: [],
        addOns: []
      };
      window.bundleCart = bundleCart;



      const cartSupports = function(supports) {
        let sups = [];
        
        if (bundleCart.product && bundleCart.product.supports) {
          sups = sups.concat(bundleCart.product.supports);
        }
        for(let cartItem of Object.keys(bundleCart)) {
          if (cartItem == "bundle") continue;
          
          if (Array.isArray(bundleCart[cartItem])) {
            for(let subItem in bundleCart[cartItem]) {
              if (subItem.supports) {
                sups = sups.concat(subItem.supports);
              }
            }
          } else if(bundleCart[cartItem] && bundleCart[cartItem].supports) {
            sups = sups.concat(bundleCart[cartItem].supports);
          }          
        }

        return (sups.includes(supports));
      }
     
      
      const filterObject = function (obj, filterProps=false) {
        if (filterProps) {
          if (bundleCart.product) {
            if (bundleCart.product.model && obj.model) {
              if (obj.model.filter( mdl => bundleCart.product.model.includes(mdl)).length == 0) return false;
            }
            if (bundleCart.product.system && obj.system) {
              if (obj.system.filter( mdl => bundleCart.product.system.includes(mdl)).length == 0) return false;
            }
          }
            
        }

        let skus = [];
        if (data.crosssell.config.excludeSKUs) {
          skus = skus.concat(data.crosssell.config.excludeSKUs);
        }
        if (bundleCart.product && bundleCart.product.excludeSKUs) {
          skus = skus.concat(bundleCart.product.excludeSKUs);
        }
        for(let cartItem of Object.keys(bundleCart)) {
          if (cartItem == "bundle") continue;
          
          if (Array.isArray(bundleCart[cartItem])) {
            for(let subItem in bundleCart[cartItem]) {
              if (subItem.excludeSKUs) {
                skus = skus.concat(subItem.excludeSKUs);
              }
            }
          } else if(bundleCart[cartItem] && bundleCart[cartItem].excludeSKUs) {
            skus = skus.concat(bundleCart[cartItem].excludeSKUs);
          }
          
        }

        if (skus.includes(obj.sku)) {
          return false;
        }
  
        return true;
  
      };
  
      const getVariant = function (id) {
        if (!id) return null;
        for (let a of Object.keys(data.parts)) {
          for (let p of data.parts[a]) {
            for (let v of p.variants) {
              if (v.id == id) {
                let ret = JSON.parse(JSON.stringify(v));
                ret.featuredImage = ret.featuredImage || p.featuredImage;
                if (a == "protection") {
                  ret.title = p.title + " " + ret.title;
                } else if (ret.title == "Default Title") {
                  ret.title = p.title;
                }
                return ret;
              };
            }
          }
        }
        return null;
      };
  
      const selectedModel = () => (bundleCart.product.model ? bundleCart.product.model.join(',') : '');
      const selectedSystem = () => (bundleCart.product.system);
  
  
      const setAddOns = function () {
        bundleCart.addOns = [];
        $('input.addOns:checked', addOnsContainer).each(function () {
          let v = getVariant($(this).val());
          if (v) bundleCart.addOns.push(v);
        })
        container.trigger('addOns:set');
      };
      $(addOnsContainer).on('change', 'input.addOns', setAddOns);
  
      const updateAddOnsHtml = function () {
        let cont = addOnsContainer;
        let type = "addOns";
  

        if (!cartReqComplete()) {
          cont.html("");
          return;
        }
        
        const  msel = new Multiselector(
          data.crosssell.translations.choose_addons, 
          type, 
          data.crosssell.translations.choose_addons_header_html, 
          data.crosssell.noicon_url,
          data.crosssell.translations.choose_addons_none
        );
        
        for (let prod of data.parts[type]) {
          if (prod.variants.length == 1) {
            if (filterObject(prod.variants[0])) {
              let disabled = (!prod.variants[0].available) ? ' disabled="disabled" ' : '';
               msel.addOption(prod.variants[0].id, prod.featuredImage, prod.title, prod.description, prod.price, disabled, prod.handle);
            }
          } else {
            for (let variant of prod.variants) {
              if (filterObject(variant)) {
                let disabled = (!variant.available) ? ' disabled="disabled" ' : '';
                const featuredImage = variant.featuredImage || prod.featuredImage;
                const title = (variant.title == selectedModel() ? prod.title : variant.title);
                msel.addOption(variant.id, featuredImage, title, variant.description || prod.description, variant.price, disabled, prod.handle, prod.title);
              }
            }
          }
        }
        msel.render(cont);
      };
      container.on('product:set', updateAddOnsHtml);
      container.on('product:set', setAddOns);
      container.on('mount:set', updateAddOnsHtml);
      container.on('mount:set', setAddOns);
      



    const setMount = function () {
        bundleCart.mount = null;
      
        $('input.mount:checked', mountContainer).each(function () {  
          let v = getVariant($(this).val());
          if (v) bundleCart.mount = v;
        })
        container.trigger('mount:set');
      };
      $(mountContainer).on('change', 'input.mount', setMount);
  
      const updateMountHtml = function () {
        let cont = mountContainer;
        let type = "mounts";
        
        
        let mountPositions = [];
        for (let mount of data.parts[type]) {
          for (let variant of mount.variants) {
            if (!filterObject(variant)) continue;
            if (!variant.available || !variant.mountPositions || !variant.mountPositions.length ) continue;
            for (let pos of variant.mountPositions) {
              if (!mountPositions.includes(pos))  mountPositions.push(pos);
            }
          }
        }
        
        if (mountPositions.length > 1) {
          const selpos = new Selector(data.crosssell.translations.choose_mountposition, "mountposition", data.crosssell.translations.choose_mountposition_header_html);
          for (let mountpos of mountPositions) {
            if (!data.crosssell.mountpositions[mountpos]) {
              selpos.addOption(mountpos, null, mountpos, null, null, !bundleCart.product);
            } else {
              let mposdata = data.crosssell.mountpositions[mountpos]
              selpos.addOption(mountpos, mposdata.image, mposdata.title, mposdata.text, null, !bundleCart.product);
            }
          }
          if (!bundleCart.product && selpos.options.length > 0) {
            selpos.unshiftOption(null, null, data.crosssell.translations.select_case_first, null, null, true);
          }
          selpos.render(mposcont);
        }
              

        let mposfilter = $('input.mountposition:checked', mposcont).val();

        let filterByMpos = function(variant) {
          if (mountPositions.length <= 1) return true;
          if (!mposfilter) return true;
          if (!filterObject(variant)) return false;
          
          if (!variant.mountPositions || variant.mountPositions.length == 0)  return true;

          return variant.mountPositions.includes(mposfilter);
        }
        
        const sel = new Selector(data.crosssell.translations.choose_mount, "mount", mountPositions.length <= 1 ? data.crosssell.translations.choose_mount_header_html : '');
        for (let mount of data.parts[type]) {
          if (mount.variants.length == 1) {
            if (!mount.variants[0].available) continue;
            if (!filterByMpos(mount.variants[0])) continue;
            if (!bundleCart.product) {
              sel.addOption(mount.variants[0].id, mount.featuredImage, mount.title, mount.description, null, true);
            } else if (filterObject(mount)) {
              sel.addOption(mount.variants[0].id, mount.featuredImage, mount.title, mount.description, null, !mount.variants[0].available);
            }
          } else {
            for (let variant of mount.variants) {
              if (!variant.available) continue;
              if (!filterByMpos(variant)) continue;
              if (!bundleCart.product) {
                sel.addOption(variant.id, variant.featuredImage, variant.title, variant.description, null, true);
              } else if (filterObject(variant)) {
                sel.addOption(variant.id, variant.featuredImage, variant.title, variant.description, null, !variant.available);
              }
            }
          }
        }
        if (!bundleCart.product && sel.options.length > 0) {
          sel.unshiftOption(null, null, data.crosssell.translations.select_case_first, null, null, true);
        }
        sel.render(mcont);
        if ( !$('input.mount:checked', mcont).val() && bundleCart.mount)  {
          bundleCart.mount = null;
          container.trigger('mount:set');
        }
      };
      $(mountContainer).on('change', 'input.mountposition', updateMountHtml);
      container.on('product:set', updateMountHtml);
      container.on('product:set', setMount);
      
      
      const setOtherMounts = function () {
        bundleCart.otherMounts = [];
        $('input.otherMounts:checked', otherMountsContainer).each(function () {        
          let v = getVariant($(this).val());
          if (v) bundleCart.otherMounts.push(v);
        })
        container.trigger('otherMounts:set');
      };
      $(otherMountsContainer).on('change', 'input.otherMounts', setOtherMounts);
  
      const updateOtherMountsHtml = function () {
        let cont = otherMountsContainer;
        let type = "otherMounts";
  
        
        if (!cartReqComplete()) {
          cont.html("");
          return;
        }
        
        const  msel = new Multiselector(
          data.crosssell.translations.choose_othermounts, 
          type, 
          data.crosssell.translations.choose_othermounts_header_html, 
          data.crosssell.noicon_url,
          data.crosssell.translations.choose_othermounts_none
        );
        for (let prod of data.parts[type]) {
          if (prod.variants.length == 1) {
            if (filterObject(prod.variants[0])) {
              let disabled = (!prod.variants[0].available) ? ' disabled="disabled" ' : '';
              if (disabled) continue;
              msel.addOption(prod.variants[0].id, prod.featuredImage, prod.title, prod.description, prod.price, disabled, prod.handle);
            }
          } else {
            for (let variant of prod.variants) {
              if (filterObject(variant)) {
                let disabled = (!variant.available) ? ' disabled="disabled" ' : '';
                if (disabled) continue;
                const featuredImage = variant.featuredImage || prod.featuredImage;
                const title = (variant.title == selectedModel() ? prod.title : variant.title);
                msel.addOption(variant.id, featuredImage, title, variant.description || prod.description, variant.price, disabled, prod.handle, prod.title);
              }
            }
          }
        }
        msel.render(cont);
      };
      container.on('product:set', updateOtherMountsHtml);
      container.on('product:set', setOtherMounts);
      container.on('mount:set', updateOtherMountsHtml);
      container.on('mount:set', setOtherMounts);

  
      const setCable = function () {
        bundleCart.cable = getVariant($('input.cable:checked', cableContainer).val());
        container.trigger('cable:set');
      };
      $(cableContainer).change('input.cable', setCable);
  
      const updateCableHtml = function () {
        let cont = cableContainer;
        let type = "cable";
        
        const sel = new Selector(data.crosssell.translations.choose_cable, type, data.crosssell.translations.choose_cable_header_html);

        if (!cartSupports('cable')) {
          sel.render(cont);
          return;
        }

        for (let prod of data.parts[type]) {
          if (prod.variants.length == 1) {
            if (filterObject(prod.variants[0])) {
              let disabled = (!prod.variants[0].available) ? ' disabled="disabled" ' : '';
              if (disabled) continue;
              sel.addOption(prod.variants[0].id, prod.featuredImage, prod.title, prod.description || "", prod.price, disabled);
            }
          } else {
            for (let variant of prod.variants) {
              if (filterObject(variant)) {
                let disabled = (!variant.available) ? ' disabled="disabled" ' : '';
                if (disabled) continue;
                const featuredImage = variant.featuredImage || prod.featuredImage;
                const title = (variant.title == selectedModel() ? prod.title : variant.title);
                sel.addOption(variant.id, featuredImage, title, variant.description || prod.description || "", variant.price, disabled);
              }
            }
          }
        }
        if (sel.hasOptions) {
          sel.addOption(null, data.crosssell.noicon_url, data.crosssell.translations.choose_cable_none, '', 0);
        }
        sel.render(cont);
      };
      
      container.on('charging:set', updateCableHtml);
      container.on('charging:set', setCable);
      container.on('dampeing:set', updateCableHtml);
      container.on('dampeing:set', setCable);
      container.on('mount:set', updateCableHtml);
      container.on('mount:set', setCable);
  
      const setCharging = function () {
        bundleCart.charging = getVariant($('input.charging:checked', chargingContainer).val());
        container.trigger('charging:set');
      };
      $(chargingContainer).on('change', 'input.charging', setCharging);
  
      
      const updateChargingHtml = function () {
        let cont = chargingContainer;
        let type = "charging";
        const currentVal = $('input.' + type + ':checked', cont).val();
  
         const sel = new Selector(data.crosssell.translations.choose_charging, type, data.crosssell.translations.choose_charging_header_html);
        
        if (!bundleCart.mount) {
          sel.render(cont);
          setCharging();
          return;
        }
        
        for (let prod of data.parts[type]) {
          if (prod.variants.length == 1) {
            if (filterObject(prod.variants[0])) {
              let disabled = (!prod.variants[0].available) ? ' disabled="disabled" ' : '';
              if (disabled) continue;
              sel.addOption(prod.variants[0].id, prod.featuredImage, prod.title, prod.description, prod.price, disabled);
            }
          } else {
            for (let variant of prod.variants) {
              if (filterObject(variant)) {
                let disabled = (!variant.available) ? ' disabled="disabled" ' : '';
                if (disabled) continue;
                const featuredImage = variant.featuredImage || prod.featuredImage;
                const title = (variant.title == selectedModel() ? prod.title : variant.title);
                
                sel.addOption(variant.id, featuredImage, title, variant.description || prod.description, variant.price, disabled);
              }
            }
          }
        }
        if (sel.hasOptions) {
          sel.addOption(null, data.crosssell.noicon_url,  data.crosssell.translations.choose_charging_none, '', 0);
        }
        sel.render(cont);
        
        setCharging();
      };
      container.on('mount:set', updateChargingHtml);
      container.on('mount:set', setCharging);
      container.on('dampening:set', updateChargingHtml);
      container.on('dampening:set', setCharging);
      
  
      const setPowerbank = function () {
        bundleCart.powerbank = getVariant($('input.powerbank:checked', powerbankContainer).val());
        container.trigger('powerbank:set');
      };
      $(powerbankContainer).change('input.powerbank', setPowerbank);
  
      const updatePowerbankHtml = function () {
        let cont = powerbankContainer;
        let type = "powerbank";
        
        
        const sel = new Selector(data.crosssell.translations.choose_powerbank, type, data.crosssell.translations.choose_powerbank_header_html);
        
        if (!bundleCart.mount) {
          sel.render(cont);
          return;
        }
        for (let prod of data.parts[type]) {
          if (prod.variants.length == 1) {
            if (filterObject(prod.variants[0])) {
              let disabled = (!prod.variants[0].available) ? ' disabled="disabled" ' : '';
              if (disabled) continue;
               sel.addOption(prod.variants[0].id, prod.featuredImage, prod.title, prod.description, prod.price, disabled);
            }
          } else {
            for (let variant of prod.variants) {
              if (filterObject(variant)) {
                let disabled = (!variant.available) ? ' disabled="disabled" ' : '';
                if (disabled) continue;
                const featuredImage = variant.featuredImage || prod.featuredImage;
                const title = (variant.title == selectedModel() ? prod.title : variant.title);
                
                sel.addOption(variant.id, featuredImage, title, variant.description || prod.description, variant.price, disabled);
              }
            }
          }
        }
        if (sel.hasOptions) {
          sel.addOption(null, data.crosssell.noicon_url, data.crosssell.translations.choose_powerbank_none, '', 0);
        }
        sel.render(powerbankContainer);
      };
      container.on('mount:set', updatePowerbankHtml);
      
      const setDampening = function () {
        const variant = getVariant($('input.dampening:checked', dampeningContainer).val());
        bundleCart.dampening = variant;
        container.trigger('dampening:set');
      };
      $(dampeningContainer).change('input.dampening', setDampening);
  
      const updateDampeningHtml = function () {
        let cont = dampeningContainer;
        let type = "dampening";

        
        const sel = new Selector(data.crosssell.translations.choose_dampening, type, data.crosssell.translations.choose_dampening_header_html);
        if (!bundleCart.mount) {
          sel.render(cont);
          return;
        }
        
        for (let prod of data.parts[type]) {
          if (prod.variants.length == 1) {
            if (filterObject(prod.variants[0])) {
              
              let disabled = (!prod.variants[0].available) ? ' disabled="disabled" ' : '';
              if (disabled) continue;
              sel.addOption(prod.variants[0].id, prod.featuredImage, prod.title, prod.description, prod.price, disabled);
            }
          } else {
            for (let variant of prod.variants) {
              if (filterObject(variant)) {
                let disabled = (!variant.available) ? ' disabled="disabled" ' : '';
                if (disabled) continue;
                const featuredImage = variant.featuredImage || prod.featuredImage;
                const title = (variant.title == selectedModel() ? prod.title : variant.title);
                
                sel.addOption(variant.id, featuredImage, title, variant.description || prod.description, variant.price, disabled);
              }
            }
          }
        }
        if (sel.hasOptions) {
          sel.addOption(null, data.crosssell.noicon_url, data.crosssell.translations.choose_dampening_none, '', 0);
        }
        sel.render(dampeningContainer);
      };
      container.on('mount:set', updateDampeningHtml);
      container.on('mount:set', setDampening);
  
      const setProtection = function () {
        const variant = getVariant($('input.protection:checked', protectionContainer).val());
        bundleCart.protection = variant;
        container.trigger('protection:set');
      };
      protectionContainer.on('change', 'input.protection', setProtection);
  
      const updateProtectionHtml = function () {
        let cont = protectionContainer;
        let type = "protection";

        if (!bundleCart.product) {
          protectionContainer.html("");
          return;
        }

        let header_html = data.crosssell.translations[ 'choose_' + type + '_header_' +(isDiscounted(type) ? 'discounted_' : '' ) +'html'];
        
        const sel = new Selector(data.crosssell.translations.choose_protection, 'protection', header_html);
        
        for (let prod of data.parts[type]) {
          if (prod.variants.length == 1) {
            if (filterObject(prod.variants[0], true)) {
              let disabled = (!prod.variants[0].available) ? ' disabled="disabled" ' : '';
              if (disabled) continue;
              found = true;
              
              sel.addOption(prod.variants[0].id, prod.featuredImage, prod.title, prod.description, prod.price, disabled);
            }
          } else {
            for (let variant of prod.variants) {
              if (filterObject(variant, true)) {
                let disabled = (!variant.available) ? ' disabled="disabled" ' : '';
                if (disabled) continue;
                
                const featuredImage = variant.featuredImage || prod.featuredImage;
                const title = prod.title;
                sel.addOption(variant.id, featuredImage, title, variant.description || prod.description, variant.price, disabled);
              }
            }
          }
        }
        if (sel.hasOptions) {
          sel.addOption(null, data.crosssell.noicon_url,  data.crosssell.translations.choose_protection_none, '', 0);
        }
        sel.render(protectionContainer);
         
      };
      container.on('product:set', updateProtectionHtml);
      container.on('product:set', setProtection);
  
      
      const updateSystemHtml = function (optionNr) {
        let variants = productVariantsForSelectorByOptions(optionNr);
        
        if (!variants.length) {
          if (optionNr == 1) option1Container.html("");
          if (optionNr == 2) option2Container.html("");
          if (optionNr == 3) option3Container.html("");
          return;
        }
        
        const sel = new Selector(data.crosssell.translations.choose_system, "option"+optionNr, data.crosssell.translations.choose_system_header_html);
        sel.addHelp(data.crosssell.help.system.id, data.crosssell.help.system.label, data.crosssell.help.system.url );

        let existing = [];
        for (let variant of variants) {
          /* if (!variant.available) continue; */
          for (let system of variant.system) {
            let systemlc = system.toLowerCase();
            if (!data.crosssell.types[systemlc]) continue;
            
            existing.push(systemlc);  
            let typeData = data.crosssell.types[systemlc];
            sel.addOption(variant['op' + optionNr], typeData.image, typeData.title, typeData.text);
          }
        }

        
        if (optionNr == 1) {
          sel.render(option1Container);  
        } else if (optionNr == 2) {
          sel.render(option2Container);  
        } else if (optionNr == 3) {
          sel.render(option3Container);  
        }
        
      };

      const productVariantsForSelectorByOptions = function (optionNr) {
        let variants = [];

        const selOp1 = $('input.option1:checked', option1Container).val();
        const selOp2 = $('input.option2:checked', option2Container).val();
        const selOp3 = $('input.option3:checked', option3Container).val();

        for (const variant of data.product.variants) {
          if (optionNr == 1) {
            if ( (!selOp2 || variant.op2 == selOp2) && (!selOp3 || variant.op3 == selOp3) ) {
              variants.push(variant);
            }
          }
          if (optionNr == 2) {
            if ( (!selOp1 || variant.op1 == selOp1) && (!selOp3 || variant.op3 == selOp3)) {
              variants.push(variant);
            }
          }
          if (optionNr == 3) {
            if ( (!selOp1 || variant.op1 == selOp1) && (!selOp3 || variant.op2 == selOp2)) {
              variants.push(variant);
            }
          }
        }

        
        return variants;
      };
      
      const setProductVariantByOptions = function () {
        let variants = [];

        const selOp1 = $('input.option1:checked', option1Container).val();
        const selOp2 = $('input.option2:checked', option2Container).val();
        const selOp3 = $('input.option3:checked', option3Container).val();

        let optionNr = 0;
        if (selOp3) optionNr = 3;
        else if (selOp2) optionNr = 2;
        else if (selOp1) optionNr = 1;

        for (const variant of data.product.variants) {
          if (optionNr == 1) {
            if (!selOp1) continue;
            if (variant.op1 != selOp1) continue;
          } else if (optionNr == 2) {
            if (!selOp1) continue;
            if (!selOp2) continue;
            if (variant.op1 != selOp1) continue;
            if (variant.op2 != selOp2) continue;
          } else if (optionNr == 3) {
            if (!selOp1) continue;
            if (!selOp2) continue;
            if (!selOp3) continue;
            if (variant.op1 != selOp1) continue;
            if (variant.op2 != selOp2) continue;
            if (variant.op3 != selOp3) continue;
          }

          variants.push(variant);
        }

        bundleCart.product = null;
        
        if (variants.length == 1) {
          
          if (variants[0].available) {
            bundleCart.product = variants[0];  
          }
          window.Events.trigger('sp:setvariant', variants[0].id);
        } else {
          window.Events.trigger('sp:setvariant', null);
        }
        container.trigger('product:set');
        return variants;
      };

      const isBundle = function() {
        return data.parts.phoneCases &&  data.parts.phoneCases.length;
      };
      
      const updateProductHtml = function() {
        if (isBundle()) {
          updateBundleProductHtml();
        } else {
          updateCaseProductHtml();
        }
      };
      
      console.log(isBundle() ? 'BUNDLE' : 'NOBUNDLE') ;
        
      const updateBundleProductHtml = function() {
        
        const sel = new Selector(data.crosssell.translations.choose_phone, "option1", data.crosssell.translations.choose_phone_header_html);
        if (data.crosssell.help.phone) {
          sel.addHelp(data.crosssell.help.phone.id, data.crosssell.help.phone.label, data.crosssell.help.phone.url );  
        }
        for(let product of data.parts.phoneCases) {
          sel.addOption(
            product.handle, 
            (data.crosssell.config.show_product_image ? product.featuredImage : null),
            product.title
          );
        }
        sel.render(option1Container);
        let selCase = $('input.option1:checked', option1Container).val();
        if (!selCase) {
          bundleCart.product = null;
          if (data.product && data.product.variants.length) {
            window.Events.trigger('sp:setvariant', data.product.variants[0].id);  
          }
        }

        
        const sel2 = new Selector(data.crosssell.translations.choose_model, "option2", data.crosssell.translations.choose_model_header_html);
        if (data.crosssell.help.model) {
          sel2.addHelp(data.crosssell.help.model.id, data.crosssell.help.model.label, data.crosssell.help.model.url );  
        }
        if (selCase) {
          for(let product of data.parts.phoneCases) {
            if (product.handle != selCase) continue;
            
            let models = [];
            for(let variant of product.variants) {
              if (!filterObject(variant)) continue;
              
              if (variant.model) {
                let model = variant.model.join(',');
                if (models[model]) continue;
                models[model] = true;
                sel2.addOption(
                  model, 
                  variant.featuredImage,
                  variant.model
                );
                  
              } else {
                /* no model - universal */
                sel2.addOption(
                  'VARIANTID:' + variant.id, 
                  variant.featuredImage,
                  variant.title
                );
              }
                
            }
            break;
          }
          sel2.render(option2Container);  
        }
        let selModel = $('input.option2:checked', option2Container).val();
        if (!selModel) {
          bundleCart.product = null;
          if (data.product && data.product.variants.length) {
            window.Events.trigger('sp:setvariant', data.product.variants[0].id);  
          }
        }

        const sel3 = new Selector(data.crosssell.translations.choose_system, "option3", data.crosssell.translations.choose_system_header_html);
        if (data.crosssell.help.system) {
          sel3.addHelp(data.crosssell.help.system.id, data.crosssell.help.system.label, data.crosssell.help.system.url );  
        }
        if (selCase && selModel) {
          if ((variantMatch = selModel.match(/^VARIANTID:(.*)$/))) {
            sel3.render(option3Container);
            
            for(let product of data.parts.phoneCases) {
              if (product.handle != selCase) continue;
              
              for(let variant of product.variants) {
                if (variant.id != variantMatch[1]) continue;

                bundleCart.product = variant;
                container.trigger('product:set');
                for(let bundleVariant of data.product.variants) {
                  if (bundleVariant.system.filter((str) => (variant.system.includes(str))).length == 0) continue;
                  window.Events.trigger('sp:setvariant', bundleVariant.id);
                  break;
                }
                
                break;
              }
              break;
            }
            
          } else {
            for(let product of data.parts.phoneCases) {
              if (product.handle != selCase) continue;
              
              let models = [];
              for(let variant of product.variants) {
                if (variant.model) {
                  let model = variant.model.join(',');
                  if (model != selModel) continue;

                  let vsystem = variant.system.join('').toLowerCase();
                  if (data.crosssell.types[vsystem]) {
                    sel3.addOption(
                      variant.id, 
                      variant.featuredImage || data.crosssell.types[vsystem].image,
                      data.crosssell.types[vsystem].title,
                      data.crosssell.types[vsystem].text
                      
                    );
                  } else {
                    sel3.addOption(
                      variant.id, 
                      variant.featuredImage,
                      variant.title
                    );  
                  }                 
                }
              }
              break;
            }
            if (sel3.hasOptions && sel3.options.length == 1) {
              option3Container.html('<input type="checkbox" checked="checked" style="display: hidden" class="option3" name="option3" value="'+sel3.options[0].value+'" >');
            }
            sel3.render(option3Container);    
          }
        }
        let selSystem = $('input.option3:checked', option3Container).val();
        if (selSystem) {
            for(let product of data.parts.phoneCases) {
              if (product.handle != selCase) continue;
              
              for(let variant of product.variants) {
                if (variant.id != selSystem) continue;

                bundleCart.product = variant;
                container.trigger('product:set');
                for(let bundleVariant of data.product.variants) {
                  if (bundleVariant.system.filter((str) => (variant.system.includes(str))).length == 0) continue;
                  window.Events.trigger('sp:setvariant', bundleVariant.id);
                  break;
                }
              }
              
              break;
            }
            sel3.render(option3Container);    
        }

      };
      
      const updateCaseProductHtml = function() {
        setProductVariantByOptions();
        
        const options = [
          { 'nr': 1, 'container': option1Container },
          { 'nr': 2, 'container': option2Container },
          { 'nr': 3, 'container': option3Container }
        ];
        for(const op of options) {
          op.val = $('input.option' + op.nr + ':checked', op.container).val();
          op.enabled = (data.product['option' + op.nr] != null);
        }
        
        let stop = false;
        for(const op of options) {
          if (!op.enabled || stop) {
            op.container.html("");
            continue;
          }

          if (!op.val) stop = true; 
          
          if (data.product['option' + op.nr + '_is'] == "system") {
            updateSystemHtml(op.nr);
            continue;
          }

          let variants = productVariantsForSelectorByOptions(op.nr);
          
          const optionSelector = new Selector(data.product['option' + op.nr].name , "option" + op.nr, data.product['option' + op.nr].name);
          for (let val of data.product['option' + op.nr].values) {
            const v = data.product.variants.filter(c => c['op' + op.nr] == val)[0];

            const ve = variants.filter(c => c['op' + op.nr] == val && c.available )[0];
            
            optionSelector.addOption(
              val, 
              (ve ? ve.featuredImage : (v ? v.featuredImage : null)),
              val,
              null,
              null,
              false /* ve ? false : true */
            );
          }
          
          $('input:enabled.option' + op.nr +'[value="' + op.val + '"]', op.container).prop('checked', true);
          optionSelector.render(op.container);

          if (!op.val) stop = true; 
        }  
      };

      $(option1Container).on('change', 'input.option1', updateProductHtml);
      $(option2Container).on('change', 'input.option2', updateProductHtml);
      $(option3Container).on('change', 'input.option3', updateProductHtml);

      
      const initial = data.product.variants.find((variant) => variant.id == data.product.selected_variant_id );
      if (initial) {
         initial.op1 && $(option1Container).append('<input type="checkbox" checked="checked" style="display: hidden" class="option1" name="option1" value="'+initial.op1+'" >');
         initial.op2 && $(option2Container).append('<input type="checkbox" checked="checked" style="display: hidden" class="option2" name="option2" value="'+initial.op2+'" >');
         initial.op3 && $(option3Container).append('<input type="checkbox" checked="checked" style="display: hidden" class="option3" name="option3" value="'+initial.op3+'" >');
      }
          
      setTimeout(function() {
         updateProductHtml();
         if (data.parts.phoneCases) {
           updateProtectionHtml();
           updateMountHtml();  
         }
         
      }, 10);

      const cartReqComplete = function () {
        let complete = !!bundleCart.product;

        if (data.crosssell.config && data.crosssell.config.required) {
          let reqArr = data.crosssell.config.required;
          if (reqArr.includes('mounts') && !bundleCart.mount) {
            complete = false;
          }
        }
        return complete;
      };
      
      const updateCart = function () {
        inlinecartContainer.html('');
        cartContainer.html('');

        const shopifyButtons = $('.product-blocks__block--buttons, #sticky-cart');

        
        if (!cartReqComplete()) {
          cartContainer.hide();
          shopifyButtons.show();
          return;
        }
        
        shopifyButtons.hide();
        
        cartContainer.css('display', 'grid');
        
        const $ul = $('<ul class="spc-minicart">').appendTo(cartContainer);
        const total = {
          sum: 0
        };
        const showInCart = function (item) {
          if (!item) return;
  
          const img = (item.featuredImage instanceof Object) ? item.featuredImage.image : item.featuredImage;
          
          const title = item.title;
          const price = priceHtml(item.price);
          if (item.price instanceof Object) {
            total.sum += item.price.sale;
          } else {
            total.sum += item.price;
          }
          
          $ul.append('<li><img class="spcs-img" src="' + img + '"/><p class="spc-minicart-title">' + title + '</p><p class="spc-minicart-price">'+ price +'</p></li>');
        }
  
        showInCart(bundleCart.product);
        showInCart(bundleCart.mount);
        showInCart(bundleCart.protection);
        showInCart(bundleCart.dampening);
        showInCart(bundleCart.powerbank);
        showInCart(bundleCart.charging);
        showInCart(bundleCart.cable);
        for (let otherm of bundleCart.otherMounts) {
          showInCart(otherm);
        }
        for (let addon of bundleCart.addOns) {
          showInCart(addon);
        }
  
        const $total = $('<div class="total">' + priceHtml(total.sum) + '</div>').prependTo(cartContainer);

        
        
        const btn = '<button class="spcs-addtocart shopify-payment-button__button--unbranded button secondary-button" type="button">'+data.crosssell.translations.add_to_cart+'</button>';
        inlinecartContainer.append(btn);
        cartContainer.append(btn);

        //inlinecartContainer.append('<div class="discount-message"></div>');
        //if (spUpdateDiscountMessage) spUpdateDiscountMessage();
        
        

      };
      
      container.on('product:set', updateCart);
      container.on('mount:set', updateCart);      
      container.on('protection:set', updateCart);
      container.on('dampening:set', updateCart);    
      container.on('powerbank:set', updateCart);    
      container.on('charging:set', updateCart);    
      container.on('cable:set', updateCart);    
      container.on('addOns:set', updateCart);    
      container.on('otherMounts:set', updateCart);

      
      $('body').on('click', '.spcs-addtocart', function () {
        const items = [];
  
        const bundleKey =  crypto.randomUUID().substr(-6);
        const bundleTitle = data.product.title;
        
        
        const addToCart = function (item, type) {
          
          if (!item) return;

          const cartProps = {
              "_bundledProductsKey": bundleKey,
              "_bundledProductsPart": type,
          };
          if (isBundle()) {
            cartProps['Bundled'] = bundleTitle + ' / ' + type;
          } else if ( type != "Case") {
            cartProps['Case'] = bundleTitle;
          }
          
          items.push({
            id: item.id,
            quantity: 1,
            properties: cartProps
          });
        }
  
        
        for (let addon of bundleCart.addOns) {
          addToCart(addon, 'AddOn');
        }
        for (let otherm of bundleCart.otherMounts) {
          addToCart(otherm, 'Other Mount');
        }
        addToCart(bundleCart.cable, 'cable');
        addToCart(bundleCart.charging, 'Charging');
        addToCart(bundleCart.powerbank, 'Powerbank');
        addToCart(bundleCart.dampening, 'Dampening');
        
        addToCart(bundleCart.protection, 'Protection');
        addToCart(bundleCart.mount, 'Mount');
        addToCart(bundleCart.product, isBundle() ? 'PhoneCase' : 'Case');
       
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: items })
        }).then((result) => {
          return result.json();        
        }).then((result) => {
          if (result.status) {
            alert(result.description);
          } else {
            window.location.href = '/cart?t=' + Date.now();  
          }
        });
      })
  
    });



    let timeout = null;
    
    const updateNumbering = function() {
      if (!timeout) {
        timeout = setTimeout(function() {
          $('#spcs-option1 h2').attr('data-nr', '1. ');
          $('#spcs-option2 h2').attr('data-nr', '1a. ');
          $('#spcs-option3 h2').attr('data-nr', '1b. ');
      
          let counter = 2;

          $('#spcs-mounts > div, #spcs-proptection > div, .spcs-container-extras > div').each(function() {
            let $h2 = $('h2', $(this));
            if ($h2.length > 0) {
              $h2.attr('data-nr', counter + '. ');
              counter++;  
            }
            
          });    
          timeout = null;
        }, 20);
      }
    };
  
//Commented out by Nikki to make change for comma
//  const priceHtml = function(price) {
//    if (price instanceof Object) {
//        return '<del>' + (price.regular / 100).toFixed(2) + '</del> <ins>'+(price.sale / 100).toFixed(2)+' '+Shopify.currency.active+'</ins>';
//    } else {
//        return (price / 100).toFixed(2) + ' ' + Shopify.currency.active;
//    }
//   };

  const priceHtml = function(price) {
    const formatPrice = (amount) => {
      const roundedAmount = Math.round(amount / 100).toLocaleString();
      
      // Dynamically place the currency symbol based on the store currency
      switch (Shopify.currency.active) {
        case 'JPY':
          return '¥' + roundedAmount;  // Yen symbol in front
        case 'USD':
          return '$' + roundedAmount;  // Dollar symbol in front
        case 'EUR':
          return '€' + roundedAmount;  // Euro symbol in front
        default:
          return roundedAmount + ' ' + Shopify.currency.active;  // Fallback to currency code after the number
      }
    };
  
    if (price instanceof Object) {
        return '<del>' + formatPrice(price.regular) + '</del> <ins>' + formatPrice(price.sale) + '</ins>';
    } else {
        return formatPrice(price);
    }
  };
  
    class Multiselector {
      constructor(title, cls, header, no_img_url, skip_selection) {
        this.title = title;
        this.class = cls;
        this.header = header;
        this.no_img_url = no_img_url;
        this.skip_selection = skip_selection;
        this.options = {};
  
        this.helpId = null;
        this.helpLabel = null;
        this.helpUrl = null;
      }
  
      addHelp(helpId, helpLabel, helpUrl) {
        this.helpId = helpId;
        this.helpLabel = helpLabel;
        this.helpUrl = helpUrl;
      }
      
  
      get hasOptions() {
        return Object.keys(this.options).length > 0;
      }
      
      addOption(value, image, title, description=null, price=null, disabled=false, handle='none', handleTitle=false) {
        this.options[handle] = this.options[handle] || [];
        this.options[handle].push({
          value, image, title, description, price, disabled, handleTitle
        });
      }
      unshiftOption(value, image, title, description=null, price=null, disabled=false, handle='none', handleTitle=false) {
        this.options[handle] = this.options[handle] || [];
        this.options[handle].unshift({
          value, image, title, description, price, disabled, handleTitle
        });
      }
  
      render(container) {
         
        let currentSelection = [];
        $('input.'+this.class+':checked', container).each(function() {
          currentSelection.push($(this).val());  
        });
  
        container.html('');
        if (this.options.length == 0) return;
  
        let found = false;
        let containerMap = {};
        let selectorMap = {};
        for(let handle of Object.keys(this.options)) {
          for (let option of this.options[handle]) {
            let disabled = option.disabled ?  ' disabled="disabled" ' : '';
            let value = ""+option.value;
            let type = this.class;

            containerMap[handle] = containerMap[handle] || $('<div>').appendTo(container);
            let optionContainer = containerMap[handle];
            
            optionContainer.attr('data-value', value);
            if (disabled) {
              optionContainer.attr('disabled', true );
              continue;
            }
            found = true;
            
            if (currentSelection.includes(value)) {
              optionContainer.append('<input checked="checked" type="checkbox" class="' + type + '" name="' + type + '" value="' + value + '" />')
            }

            selectorMap[handle] = selectorMap[handle] || new Selector(option.handleTitle || option.title, type, null, this.class + "_" + value);
            const osel = selectorMap[handle];

            if (osel.hasOptions) {
              osel.unshiftOption(value, option.image, option.title, option.description, option.price);
            } else {
              osel.addOption(value, option.image, option.title, option.description, option.price);
              osel.addOption(null, this.no_img_url, this.skip_selection.replace('%s', option.title), '');  
            }
            osel.render(optionContainer);
          }
         }
         if (found && this.header) {
           container.prepend('<h2>' + (this.header === true ? this.title : this.header) + '</h2>');
           if (this.helpLabel && this.helpUrl) {
              container.prepend('<div class="system_compatibility_link"><a href="#'+ this.helpId +'" class="compatibility__link">'+this.helpLabel+'</a></div>');
           } 
         }
      }
    }
    
    class Selector {
  
      constructor(title, cls, header, name=null) {
        this.title = title;
        this.class = cls;
        this.name = name || cls;
        this.header = header;
        this.options = [];      
        
        this.helpId = null;
        this.helpLabel = null;
        this.helpUrl = null;
      }
  
      addHelp(helpId, helpLabel, helpUrl) {
        this.helpId = helpId;
        this.helpLabel = helpLabel;
        this.helpUrl = helpUrl;
  
      }
  
      get hasOptions() {
        return this.options.length > 0;
      }
      
      addOption(value, image, title, description=null, price=null, disabled=false) {
        this.options.push({
          value, image, title, description, price, disabled
        });
      }
      popOption() {
        return this.options.pop();
      }
      unshiftOption(value, image, title, description=null, price=null, disabled=false) {
        this.options.unshift({
          value, image, title, description, price, disabled
        });
      }
  
  
      get selectboxhandle() {
        let $r = $('<label class="selector-handle">');
        $r.append('<div class="lbl">' + this.title + '</div>');
        $r.append('<svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M7 10l5 5 5-5z"></path></svg>');
        $r.on('mouseup tap', function(e) {
          e.preventDefault();
          e.stopPropagation();
          let current = $(this).next('.selector-container');
          let visible = current.is(':visible');
          $('.selector-container').fadeOut(250);
          $('.selector-handle').removeClass('open');
          if (!visible) {
            $(this).addClass('open');
            current.fadeIn(250);
          } else {
            
          }
        });
        return $r;
      }
      
      
      render(container) {
        let currentVal = $('input.'+this.class+':checked', container).val();
        //console.log('render ' + this.class  + ': ', currentVal);
        container.html('');
        if (this.options.length == 0) return;
  
        container.addClass('revealable').addClass('reveal');
        if (this.header) {
          if (this.helpLabel && this.helpUrl) {
            container.append('<div class="system_compatibility_link"><a href="#'+ this.helpId +'" class="compatibility__link">'+this.helpLabel+'</a></div>');
          } 
          container.append('<h2>' + (this.header === true ? this.title : this.header) + '</h2>');
  
        }
        
        const selectboxhandle = this.selectboxhandle;
        container.append(selectboxhandle);
        const $lst = $('<div class="selector-container">').appendTo(container);
        for (let option of this.options) {
          const disabled = (option.disabled ? ' disabled="disabled" ' : '');
          const hasDescription = option.description === null ?  '' : ' has_description ' ;
          const hasPrice = option.price ? ' has_price ' : '';
          const isHint = option.disabled && !option.value ? "is_hint" : '';
          
          const l = $('<label '+disabled+' class="' + hasDescription + isHint + '">');
          l.append('<input  '+disabled+' type="radio" class="'+this.class+'" name="'+this.name+'" value="' + option.value + '" />');
  
          if (option.image) {
            if (option.image instanceof Object) {
              l.append('<img class="spcs-img" src="' + option.image.dropdown + '"  data-product="' + option.image.image + '"  data-icon="' + option.image.icon + '" />');
            } else {
              l.append('<img class="spcs-img" src="' + option.image + '"/>');  
            }
            
          }
          let left = $('<div>').appendTo(l);
          
          left.append('<div class="spc-selector-title">' + option.title + '</div>');
          if (option.price) {
            left.append('<div class="spc-selector-price">' + priceHtml(option.price) + '</div>');
          }
          if (option.description) {
            left.append('<div class="spc-selector-description">' + option.description + '</div>');
          }
          
          $lst.append(l);
        }
        updateNumbering();
        
        const cls = this.class;
        $('input:enabled.'+cls+'[value="'+currentVal+'"]', $lst).prop('checked', 'checked');
        
        const change = function() {
          $('input.'+cls, $lst).closest('label').removeClass('selected');
  
          const selected = $('input.'+cls+':checked', $lst);
          
          selected.closest('label').addClass('selected');
  
          $lst.fadeOut(250);
          selectboxhandle.removeClass('open');
          $('.lbl', selectboxhandle).html(selected.closest('label').html());
          $('input', selectboxhandle).remove();
          $('.lbl img', selectboxhandle).each(function() {
            let icon = $(this).attr('data-icon');
            if (icon) {
              $(this).attr('src', icon);
            }
          });
          
        };
        
        $('input.'+cls, $lst).on('change', change);
        change();
        setTimeout(function() {
          container.removeClass('reveal');  
        }, 100);
        
      }
    
    }
    
  
  })(jQuery);